import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserLevel, userLevelFromString } from '@app/core/models/user-level';
import { MenuService } from '@app/menu/services/menu.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[portalIfLevel]',
  standalone: false,
})
export class IfLevelDirective implements OnInit {
  private userLevel: UserLevel;

  @Input('portalIfLevel')
  set portalIfLevel(rawLevel: string) {
    this.userLevel = userLevelFromString(rawLevel);
  }

  constructor(
    private menuService: MenuService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.menuService.menuData$.pipe(untilDestroyed(this)).subscribe((value) => {
      let levelIsEnough = this.menuService.isActive(this.userLevel);

      // If not cleared it could happen that some elements are displayed multiple times
      this.viewContainer.clear();

      if (levelIsEnough) {
        this.viewContainer.createEmbeddedView(this.template);
      }
    });
  }
}
